import React from 'react';
import { captureException } from '@askporter/exception-logger';
import { useToast } from '@askporter/toast';
import { copyToClipboard } from '@askporter/utils';
import { BreadcrumbProps } from '../../../../../../Breadcrumb';
import { Breadcrumbs } from '../../../../../../Breadcrumbs';

export type ResourceName = 'asset' | 'task';
interface DetailsPageHeaderBreadCrumbsProps {
  t: (key: string) => string;
  resourceName: ResourceName;
  resourceUid: string;
  copyBreadcrumbText: string;
  resourceBreadcrumbs: BreadcrumbProps[];
}

export const DetailsPageHeaderBreadCrumbs: React.FC<DetailsPageHeaderBreadCrumbsProps> = ({
  t,
  resourceName,
  resourceUid,
  copyBreadcrumbText,
  resourceBreadcrumbs,
}) => {
  const { showSuccess, showError } = useToast();

  // Log the current route details
  const resourcePaths = {
    asset: '/app/assets',
    task: '/app/tasks',
  };

  const copyFunction = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();

    const isSuccess = copyToClipboard(
      `${window.location.origin}${resourcePaths[resourceName]}/${resourceUid}`,
      captureException,
    );
    const message = isSuccess
      ? t(`ns.${resourceName}_list:${resourceName}_link:clipboard_success`)
      : t(`ns.${resourceName}_list:${resourceName}_link:clipboard_error`);
    if (isSuccess) {
      showSuccess(message);
    } else {
      showError(message);
    }
    return message;
  };
  const breadcrumbs = [
    { label: t(`ns.${resourceName}:header:${resourceName}_list_breadcrumb`), href: resourcePaths[resourceName] },
    ...resourceBreadcrumbs,
    { label: copyBreadcrumbText },
  ];

  return (
    <Breadcrumbs
      items={breadcrumbs}
      onCopy={copyFunction}
      copyAriaLabel={t(`ns.${resourceName}:header:${resourceName}_list_breadcrumb:aria_label`)}
      highlightLastItem
      t={t}
    />
  );
};
